import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss']
})

export class PaginationComponent {
    @Input() page: number = 1;
    @Input() pages: number = 1;

    @Output() pageChangeEvent = new EventEmitter<number>();

    public pageChange(value: number) {
        this.pageChangeEvent.emit(value);
    }

    public pagesArray(count: number) {
        if (count >= 0) {
            return new Array(count);
        }
        return [];
    }

    public isSelected(count: number) {
        let theClass = '';

        if (count === this.page) {
            theClass = 'selected';
        }

        return theClass;
    }
}